import naturalSortComparator from '../grid/comparators/NaturalSortComparator';

export const compareColumnPropertyState = (
    columnId,
    previousColumns,
    newColumns,
    columnProperty
) => {
    const getColumnState = (columns, colId) =>
        Array.isArray(columns)
            ? columns.find((item) => item.colId === colId)
            : undefined;

    const previousColumnState = getColumnState(previousColumns, columnId);
    const newColumnState = getColumnState(newColumns, columnId);

    if (!previousColumnState || !newColumnState) {
        return { hasChanged: false, newValue: undefined };
    }

    const hasChanged =
        previousColumnState[columnProperty] !== newColumnState[columnProperty];

    return { hasChanged, newValue: newColumnState[columnProperty] };
};

export const setToolbarColumnLayout = (griApi) => {
    const columnDefs = griApi.getColumnDefs();

    const columnToolPanel = griApi.getToolPanelInstance('columns');
    if (columnDefs) {
        const selectedColumns = columnDefs.filter((x) => !x.hide);
        const sortedHiddenColumns = columnDefs
            .filter((x) => x.hide)
            .sort((a, b) =>
                naturalSortComparator(
                    a.columnToolPanelLabel ?? a.headerName,
                    b.columnToolPanelLabel ?? b.headerName
                )
            );
        const sortedToolPanelColumnDefs = [
            ...selectedColumns,
            ...sortedHiddenColumns,
        ];
        columnToolPanel?.setColumnLayout(sortedToolPanelColumnDefs);
    }
};
